import { render, staticRenderFns } from "./ActivityDetail.vue?vue&type=template&id=610a0f81&"
import script from "./ActivityDetail.vue?vue&type=script&lang=ts&"
export * from "./ActivityDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ActivityDetail.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports